var _defs, _path, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrey03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4c708b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.62,52.18c0,.76-.05,1.51-.11,2.25l1.65,1.66c.18-1.28.3-2.58.3-3.91,0-12.54-8.21-23.2-19.54-26.9v1.96c10.29,3.63,17.69,13.42,17.69,24.93Zm-52.8,2.25c-.06-.74-.11-1.49-.11-2.25,0-11.51,7.4-21.3,17.69-24.93v-1.96c-11.32,3.7-19.54,14.35-19.54,26.9,0,1.33.12,2.63.3,3.91l1.66-1.66Zm26.34,24.21c-7.11,0-13.57-2.84-18.33-7.42l-1.3,1.31c5.1,4.92,12.01,7.96,19.63,7.96s14.54-3.04,19.63-7.96l-1.31-1.31c-4.76,4.59-11.22,7.42-18.33,7.42Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.13,33.15c0-1.62-1.33-2.95-2.95-2.95h-9.07c-1.62,0-2.95,1.33-2.95,2.95v6.89h14.97v-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.15,24.01c0,2.48-2.01,4.5-4.5,4.5s-4.5-2.01-4.5-4.5,2.01-4.5,4.5-4.5,4.5,2.01,4.5,4.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.29,61.31c0-1.62-1.33-2.95-2.95-2.95h-9.07c-1.62,0-2.95,1.33-2.95,2.95v6.89h14.97v-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.3,52.17c0,2.48-2.01,4.5-4.5,4.5s-4.5-2.01-4.5-4.5,2.01-4.5,4.5-4.5,4.5,2.01,4.5,4.5Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.51,61.71c0-1.62-1.33-2.95-2.95-2.95h-9.07c-1.62,0-2.95,1.33-2.95,2.95v6.89h14.97v-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.52,52.57c0,2.48-2.01,4.5-4.5,4.5s-4.5-2.01-4.5-4.5,2.01-4.5,4.5-4.5,4.5,2.01,4.5,4.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrey03);
export default __webpack_public_path__ + "static/media/grey03.437704d7f03434fa703c0726898faae7.svg";
export { ForwardRef as ReactComponent };